import { render, staticRenderFns } from "./RelationshipArray.vue?vue&type=template&id=6807030e&scoped=true&"
import script from "./RelationshipArray.vue?vue&type=script&lang=js&"
export * from "./RelationshipArray.vue?vue&type=script&lang=js&"
import style0 from "./RelationshipArray.vue?vue&type=style&index=0&id=6807030e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807030e",
  null
  
)

export default component.exports